// A mixin providing analytics-related functionality
import { trackAddToCart, trackVehicleAdded, getTransactionId } from '@/fcoModules/analytics';
import { ProductOrigin } from '@/common/constants/ordering';
import { mapState } from 'vuex';

export default {
    props: {
        pageNumber: {
            type: Number,
            default: 1,
        },
        currentPosition: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        ...mapState('miniQuote', {
            worksheetHeaderId: (state) => state.quoteDetails.worksheetHeaderId,
        }),
        activityTracking() {
            return this.$store.state.activityTracking;
        },
        quoteDetails() {
            return this.$store.state.miniQuote.quoteDetails;
        },
        $_analyticsMixin_transactionIdForAnalytics() {
            if (this.worksheetHeaderId) {
                return this.worksheetHeaderId;
            }

            return getTransactionId();
        },
    },
    methods: {
        $_analyticsMixin_setPDPViewedFromData(page) {
            this.$store.dispatch('activityTracking/setPDPViewFrom', page);
            this.$store.dispatch('activityTracking/setPDPResultsPageFrom', this.pageNumber);
            this.$store.dispatch('activityTracking/setPDPResultsIndexFrom', this.currentPosition);
        },
        $_analyticsMixin_buildAnalyticsCategory(analyticsCategory, itemOrigin, itemOriginDetails) {
            return analyticsCategory || (itemOrigin === ProductOrigin.CATALOG ? itemOriginDetails : itemOrigin);
        },
        $_analyticsMixin_trackVehicleAdded(method) {
            trackVehicleAdded(method, this.$_analyticsMixin_transactionIdForAnalytics, this.activityTracking.activity.vehicleAddedFrom);
        },
        $_analyticsMixin_trackAddToCart(items = [], from = '', responseData = null, cartTotalBeforeAdd = null) {
            const { worksheetHeaderId } = this.quoteDetails;

            // Get cart total AFTER adding items
            // Access store directly instead of computed property to get the latest value
            const cartTotalValue =
                responseData?.quoteData?.worksheetForm?.subtotalCost ??
                this.$store?.state?.miniQuote?.quoteDetails?.subtotalCost ??
                this.quoteDetails?.subtotalCost ??
                0;

            // Get cart total BEFORE adding items
            // If provided explicitly, use it; otherwise calculate it
            let userCartValue;
            if (cartTotalBeforeAdd !== null) {
                userCartValue = cartTotalBeforeAdd;
            } else {
                // Fallback: calculate by subtracting added items from current total
                const addedItemsTotal = items.reduce((total, item) => {
                    const itemTotal = (item.itemCost || 0) * (item.itemQuantity || 0);
                    return total + itemTotal;
                }, 0);
                userCartValue = Math.max(0, cartTotalValue - addedItemsTotal);
            }

            trackAddToCart({ from, items, worksheetHeaderId, cartTotalValue, userCartValue });
        },
    },
};
